<template>
  <div class="">
    <div v-for="(item, i) in list" :key="i">
      <vacation-details-list-mob-item :item="item" />
    </div>
  </div>
</template>

<script>
import VacationDetailsListMobItem from "./VacationDetailsListMobItem.vue";
export default {
  components: { VacationDetailsListMobItem },
  props: {
    list: Array,
  },
  computed: {},
  data() {
    return {
      show: false,
    };
  },
  methods: {},
};
</script>

<style scoped>
* {
  padding: 0px;
  margin: 0px;
}

.card-text {
  font-size: 0.875rem !important;
  color: var(--black) !important;
}

.text-caption-color {
  color: #8b8b8b;
}

.state .v-icon {
  font-size: 1rem;
}
</style>